export const DOCUMENTATION_GET_LIST = 'DOCUMENTATION_GET_LIST'
export const DOCUMENTATION_GET_PAGE_FROM_URL = 'DOCUMENTATION_GET_PAGE_FROM_URL'
export const DOCUMENTATION_GET_PAGE = 'DOCUMENTATION_GET_PAGE'
export const DOCUMENTATION_GET_ATTACHMENT = 'DOCUMENTATION_GET_ATTACHMENT'
export const DOCUMENTATION_SHOW_MODAL = 'DOCUMENTATION_SHOW_MODAL'
export const DOCUMENTATION_HIDE_MODAL = 'DOCUMENTATION_HIDE_MODAL'
export const DOCUMENTATION_ADD_GROUP = 'DOCUMENTATION_ADD_GROUP'
export const DOCUMENTATION_ADD_DOCUMENT = 'DOCUMENTATION_ADD_DOCUMENT'
export const DOCUMENTATION_DELETE_DOCUMENT = 'DOCUMENTATION_DELETE_DOCUMENT'
export const DOCUMENTATION_EDIT_DOCUMENT = 'DOCUMENTATION_EDIT_DOCUMENT'
export const DOCUMENTATION_EDIT_DOCUMENT_DETAILS = 'DOCUMENTATION_EDIT_DOCUMENT_DETAILS'
export const DOCUMENTATION_UPDATE_CONTENT = 'DOCUMENTATION_UPDATE_CONTENT'
export const DOCUMENTATION_UPLOAD_ATTACHMENT = 'DOCUMENTATION_UPLOAD_ATTACHMENT'
export const DOCUMENTATION_DELETE_GROUP = 'DOCUMENTATION_DELETE_GROUP'
export const DOCUMENTATION_SET_SHOW_TREE_PANEL = 'DOCUMENTATION_SET_SHOW_TREE_PANEL'
